import { useEffect, useState } from 'react';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import SequenceForm from './SequenceForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiServices from '../../services/service';
import { singleRowAddUpdateInStore } from '../../redux/actions';
import BasicDetailsForm from './basicDetailsForm';
import AudienceFilter from './audienceFilter';
import EmailSteps from './emailSteps';
import Insights from './insights';
import { validationSchemaBasicDetails } from './validationSchemaBasicDetails';
import Loader from '../../shared/component/Loader';
import { useDispatch } from 'react-redux';

const AddSmartSequence = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState([]);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('basicDetails');
  const [tabsEnabled, setTabsEnabled] = useState(false);

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    const convertedValue = value;
    setFormData({
      ...formData,
      [name]: convertedValue,
    });
    setFormEdited(true);
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };
  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    const updatedFormData = {
      ...formData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'sequenceOwnerId') {
      setFormData({
        ...formData,
        sequenceOwnerId: selectedId,
        sequenceOwner: selectedValue,
      });

      setFormEdited(true);
    } else if (name === 'sequenceTypeId') {
      setFormData({
        ...formData,
        sequenceTypeId: selectedId,
        sequenceType: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'statusId') {
      setFormData({
        ...formData,
        statusId: selectedId,
        status: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'filter') {
      setFormData({
        ...formData,
        filterId: selectedId,
        filter: selectedValue,
      });
      setFormEdited(true);
    }
  };

  // Handle radio button change
  const handleRadioChange = (event) => {
    const { value } = event.target;
    setFormData((prev) => ({
      ...prev,
      sendOption: value, // Update the selected radio button
    }));
  };

  // Handle date and time change
  const handleDateTime = (e) => {
    const dataTime = e.target.value;
    setFormData({
      ...formData,
      scheduledDateTime: dataTime,
    });
    setFormEdited(true);
  };

  const handleCancel = () => {
    navigate('/campaigns', { state: { activeTab: 'smartSq' } });
  };

  // const updateList = async (msg, id) => {
  //   setLoading(false);
  //   toast.success(msg, {
  //     position: 'top-right',
  //   });

  //   navigate('/campaigns/smartSequence', { state: { activeTab: 'smartSq' } });

  //   //   try {
  //   dispatch(
  //     singleRowAddUpdateInStore({
  //       moduleName: 'SmartSequence',
  //       id: formData.type === 'add' ? id : formData.id,
  //       rowIndex: formData.rowIndex,
  //     })
  //   );

  //   // if (formData.from === 'view') {
  //   //   navigate(
  //   //     `/campaigns/viewCampaign?id=${formData.id}&pageNo=${gridData?.inputPayload?.pageNumber}`
  //   //   );
  //   // } else {
  //   //   navigate('/campaigns');
  //   // }
  //   //   } catch (error) {
  //   //     console.error('Failed to fetch and update Campaign:', error);
  //   //     toast.error('Something went wrong while updating the list.', {
  //   //       position: 'top-right',
  //   //     });
  //   //   }
  // };

  const updateList = async (msg, id) => {
  setLoading(false);
  toast.success(msg, {
    position: 'top-right',
  });

  // ✅ Instead of navigating away, stay on the page
  // navigate('/campaigns/smartSequence', { state: { activeTab: 'smartSq' } });

  // ✅ Enable next tabs
  setTabsEnabled(true);

  // ✅ Move automatically to next tab (Audience Filters)
  setActiveTab('audienceFilters');

  // ✅ Update Redux store (if needed)
  dispatch(
    singleRowAddUpdateInStore({
      moduleName: 'SmartSequence',
      id: formData.type === 'add' ? id : formData.id,
      rowIndex: formData.rowIndex,
    })
  );
};

  const handleSubmit = async (formData) => {
    setLoading(true);
    setErrorMsg({});

    try {
      await validationSchemaBasicDetails.validate(formData, { abortEarly: false });

      const method = formData?.type === 'add' ? 'createSmartSquence' : 'updateSmartSequence';
      const response = await apiServices[method](formData);

      if (response.status === 200) {
  const id = response.data;
  const action = formData?.type === 'edit' ? 'Updated' : 'Created';
  toast.success(`Smart Sequence ${action} Successfully!`, { position: 'top-right' });

  // ✅ Enable next tabs
  setTabsEnabled(true);

  // ✅ Optionally store returned ID in formData (if created)
  if (formData?.type === 'add') {
    setFormData((prev) => ({ ...prev, id }));
  }

  updateList(`Smart Sequence ${action} Successfully!`, formData?.type === 'add' ? id : '');
} else {
        handleApiErrors(response.errors);
      }
    } catch (error) {
      if (error.name === 'ValidationError') {
        const fieldErrors = {};
        error.inner.forEach((err) => {
          fieldErrors[err.path] = err.message;
        });
        setErrorMsg(fieldErrors);
      } else if (error.response?.data?.errors) {
        handleApiErrors(error.response.data.errors);
      } else {
        toast.error('Something went wrong', { position: 'top-right' });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleApiErrors = (errors) => {
    Object.keys(errors).forEach((key) => {
      errors[key].forEach((msg) => toast.error(msg, { position: 'top-right' }));
    });
  };

  // useEffect(() => {
  //   let updatedFormData = {
  //     ...formData,
  //     type: location.pathname.includes('create') ? 'add' : 'edit',
  //   };
  //   if (
  //     location.pathname.includes('edit') ||
  //     (location.pathname.includes('view') && location.state)
  //   ) {
  //     let type = location.pathname.includes('edit') ? 'edit' : 'view';
  //     handleSmartSeqGetById(location?.state?.id, type);
  //   }
  //   setFormData(updatedFormData);
  // }, [location]);

  useEffect(() => {
  let updatedFormData = {
    ...formData,
    type: location.pathname.includes('create')
      ? 'add'
      : location.pathname.includes('edit')
      ? 'edit'
      : 'view',
  };

  // ✅ If we're editing an existing Smart Sequence
  if (
    location.pathname.includes('edit') ||
    (location.pathname.includes('view') && location.state)
  ) {
    let type = location.pathname.includes('edit') ? 'edit' : 'view';
    handleSmartSeqGetById(location?.state?.id, type);

    // ✅ Enable tabs for edit mode
    if (location.pathname.includes('edit')) {
      setTabsEnabled(true);
    }
  }

  // ✅ For "create" flow → tabs will stay disabled until Save is done
  if (location.pathname.includes('create')) {
    setTabsEnabled(false);
  }

  setFormData(updatedFormData);
}, [location]);


  // Smart Sequence Get By Id API Call
  const handleSmartSeqGetById = (id, type) => {
    if (id) {
      let req = {
        id: id,
      };
      setLoading(true);
      apiServices.SmartSequenceGetSequenceDetailsById(req).then((response) => {
        if (response.status === 200) {
          setLoading(false);
          const data = response.data;
          setFormData({
            ...data,
            type: type,
            rowIndex: location?.state?.rowIndex,
          });
          setSelectedOptions({
            sequenceOwner: { value: data.sequenceOwnerId, label: data.sequenceOwner },
            sequenceType: { value: data.sequenceTypeId, label: data.sequenceType },
            status: { value: data.statusId, label: data.status },
          });
        } else {
          toast.error('Something went wrong', {
            position: 'top-right',
          });
        }
      });
    }
  };

  return (
    <div className="addlead_container">
      <div className="viewHeader viewshadow">
        <HeaderProfileBlock moduleName={'Sequence'} localData={formData} />
        {formData?.type !== 'view' && (
          <div className="rightAction">
            <button type="button" className="btn btn-outline-primary" onClick={handleCancel}>
              Cancel
            </button>

            {activeTab === 'basicDetails' && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleSubmit(formData)}
              >
                Save
              </button>
            )}
          </div>
        )}

        {formData?.type === 'view' && (
          <div className="rightAction">
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
              onClick={() =>
                navigate(`/campaigns/editSmartSequence`, {
                  state: formData,
                })
              }
            >
              Edit
            </button>
          </div>
        )}
      </div>
      <div className="createFormwithTabs">
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          <button
            className={`nav-link ${activeTab === 'basicDetails' ? 'active' : ''}`}
            id="basicDetails-tab"
            data-bs-toggle="tab"
            data-bs-target="#basicDetails"
            type="button"
            role="tab"
            aria-controls="basicDetails"
            aria-selected="true"
            onClick={() => setActiveTab('basicDetails')}
            // disabled={!tabsEnabled}
          >
            Basic Details
          </button>
          <button
            className={`nav-link ${activeTab === 'audienceFilters' ? 'active' : ''}`}
            id="audienceFilters-tab"
            data-bs-toggle="tab"
            data-bs-target="#audienceFilters"
            type="button"
            role="tab"
            aria-controls="audienceFilters"
            aria-selected="true"
            onClick={() => setActiveTab('audienceFilters')}
            disabled={!tabsEnabled}
          >
            Audience Filters
          </button>

          <button
            className={`nav-link ${activeTab === 'emailSteps' ? 'active' : ''}`}
            id="emailSteps-tab"
            data-bs-toggle="tab"
            data-bs-target="#emailSteps"
            type="button"
            role="tab"
            aria-controls="emailSteps"
            aria-selected="true"
            onClick={() => setActiveTab('emailSteps')}
            disabled={!tabsEnabled}
          >
            {' '}
            Email Steps
          </button>
          <button
            className={`nav-link ${activeTab === 'insights' ? 'active' : ''}`}
            id="insights-tab"
            data-bs-toggle="tab"
            data-bs-target="#insights"
            type="button"
            role="tab"
            aria-controls="insights"
            aria-selected="true"
            onClick={() => setActiveTab('insights')}
            // disabled={!tabsEnabled}
          >
            {' '}
            Insights
          </button>
          {formData?.type == 'view' && (
            <button
              className={`nav-link ${activeTab === 'timeline' ? 'active' : ''}`}
              id="timeline-tab"
              data-bs-toggle="tab"
              data-bs-target="#timeline"
              type="button"
              role="tab"
              aria-controls="timeline"
              aria-selected="true"
              onClick={() => setActiveTab('timeline')}
            >
              {' '}
              Timeline
            </button>
          )}
        </div>
        <div className="tab-content" id="nav-tabContent">
          {loading && <Loader />}
          {activeTab === 'basicDetails' && (
            <BasicDetailsForm
              formData={formData}
              handleChange={handleChange}
              handleChangeForm={handleChangeForm}
              handleDateTime={handleDateTime}
              handleSubmit={handleSubmit}
              errormsg={errormsg}
            />
          )}
          {activeTab === 'audienceFilters' && <AudienceFilter formData={formData} />}
          {activeTab === 'emailSteps' && <EmailSteps formData={formData} />}
          {activeTab === 'insights' && <Insights formData={formData} />}
        </div>
        {/* <SequenceForm
        formData={formData}
          handleChange={handleChange}
          handleRadioChange={handleRadioChange}
          handleDateTime={handleDateTime}
          handleChangeForm={handleChangeForm}
          handleSubmit={handleSubmit}
        /> */}
      </div>
    </div>
  );
};

export default AddSmartSequence;
